function useCurrencyParser(number, currency="rp") {
    const reverse = (s) => {
        return s.split("").reverse().join("");
    };
    const strHarga = number.toString();
    let count = 0;
    let reversedHarga = "";
    for (let i = strHarga.length - 1; i >= 0; i--) {
        if (count == 3) {
            count = 1;
            reversedHarga += `.${strHarga[i]}`;
        } else {
            reversedHarga += strHarga[i];
            count++;
        }
    }
    const reversed = reverse(reversedHarga);
    if (currency == "rp") {
        return `Rp ${reversed}`;
    }
    return reversed;
}

export default useCurrencyParser;
